import {
  LIST_TABLE_CONTENTS_LABEL_DISPLAY,
  SIZE_COVER,
  SCALE,
} from '../../constants';
import PageFooter from '../common/PageFooter';
import bgCover from '@/assets/image/pdfexport/bg-cover.png';
import { Box, Typography, withStyles } from '@material-ui/core';
import React from 'react';

const width = SIZE_COVER.width * SCALE;
const height = SIZE_COVER.height * SCALE;

const CustomContainer = withStyles({
  root: {
    padding: `0 ${80 * SCALE}px`,
    height,
    width,
    margin: '0 auto',
    backgroundImage: `url(${bgCover})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: `${64 * SCALE}px`,
  },
})(Box);
const Title = withStyles({
  root: {
    color: '#333',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 20 * SCALE,
    lineHeight: `${28 * SCALE}px`,
    marginBottom: `${24 * SCALE}px`,
  },
})(Typography);

const Paragraph = withStyles({
  root: {
    color: '#333',
    fontFamily: 'OpenSans',
    fontWeight: 400,
    fontSize: 12 * SCALE,
    lineHeight: `${18 * SCALE}px`,
    marginTop: `${8 * SCALE}px`,
    marginBottom: `${8 * SCALE}px`,
  },
})(Typography);

const ThankYou = ({ totalPages }) => {
  return (
    <CustomContainer>
      <Box display="flex" flexDirection="column" minHeight="100%">
        <Title>It's not goodbye. It's see you later …</Title>

        <Paragraph>
          Thank you for the wonderful memories of your health screening with us.
          We hope you enjoyed this great start as much as we did.
        </Paragraph>
        <Paragraph>
          Complete health and wellness? It is not just a screening for us. It is
          a lifestyle. hope you enjoyed this great start as much as we did.
        </Paragraph>
        <Paragraph>
          So this is definitely not goodbye, as we have more than this to offer.
          Talk to our team of in-house team dieticians, nutritionists, doctors,
          mental health coaches, fitness trainers, chefs and program
          consultants. Leave it to us to design tailored solutions for you from
          health to smell to cells (yes, that's how we do it). You name it, we
          game it. Now, that is what's so Super about us.
        </Paragraph>
        <Paragraph>We are ready whenever you are - ask@minmed.sg.</Paragraph>
        <Paragraph>
          PS. If you like our services or have other feedback, do ask@minmed.sg.
          Or as they say, the best compliment is none other than a
          recommendation.
        </Paragraph>
        <PageFooter
          page={totalPages}
          totalPages={totalPages}
          title={LIST_TABLE_CONTENTS_LABEL_DISPLAY.ThankYou}
        />
      </Box>
    </CustomContainer>
  );
};

export default ThankYou;
